import { createSelector } from '@reduxjs/toolkit';

import { ASYNC_STATUS } from '@/packages/typesafe-result';

import { type IHighwayDirection } from '@/microfrontends/filters/shared/types/highways';

import { selectCurrentLocationIdSafe } from '../../location/selectors/selectCurrentLocaitonId';

import { highwaysSelector } from './root';

export const selectHighways = createSelector(
  [highwaysSelector, selectCurrentLocationIdSafe],
  (directions, locationId): IHighwayDirection[] => directions[locationId]?.data || [],
);

export const selectHighwaysStatus = createSelector(
  [highwaysSelector, selectCurrentLocationIdSafe],
  (directions, locationId) => directions[locationId]?.status || ASYNC_STATUS.IDLE,
);
